import { RibbonGroupBase } from '../ribbon-interfaces';
export const COMMENT_ID = '_insert_comment';
/**
 * Comments group implementation for Insert tab
 * @private
 */
export class CommentsGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon items for Comments group
     * @returns {RibbonGroupModel} - Returns the Ribbon items for Comments group
     * @private
     */
    getGroupModel() {
        return {
            header: this.localObj.getConstant('Comments'),
            groupIconCss: 'e-icons e-de-cnt-cmt-add',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Comments'),
            collections: [{
                    items: [{
                            type: 'Button',
                            keyTip: 'C',
                            buttonSettings: {
                                content: this.localObj.getConstant('New Comment'),
                                iconCss: 'e-icons e-de-cnt-cmt-add',
                                isToggle: false,
                                clicked: this.newCommentHandler.bind(this)
                            },
                            id: this.ribbonId + COMMENT_ID,
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Add a comment about the current selection')
                            }
                        }]
                }]
        };
    }
    newCommentHandler() {
        this.container.documentEditor.editorModule.isUserInsert = true;
        this.container.documentEditor.editorModule.insertComment('');
        this.container.documentEditor.editorModule.isUserInsert = false;
    }
    /**
     * Update selection to reflect current state
     * @returns {void}
     * @private
     */
    updateSelection() {
        const isHeaderFooter = this.documentEditor.selection.contextType.indexOf('Header') >= 0 ||
            this.documentEditor.selection.contextType.indexOf('Footer') >= 0;
        const shouldDisable = isHeaderFooter ||
            this.container.documentEditor.selection.isinFootnote ||
            this.container.documentEditor.selection.isinEndnote ||
            this.container.documentEditor.commentReviewPane.commentPane.isEditMode || this.container.documentEditor.selection.isInShape;
        this.enableDisableComment(!shouldDisable);
    }
    /**
     * @param {boolean} enable - Enable disable the comment
     * @returns {void}
     * @private
     */
    enableDisableComment(enable) {
        const ribbon = this.container.ribbon.ribbon;
        if (enable) {
            ribbon.enableItem(this.ribbonId + COMMENT_ID);
        }
        else {
            ribbon.disableItem(this.ribbonId + COMMENT_ID);
        }
    }
}
